import { useState } from "react";
import { faqs } from "@/mocks/data";

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mx-auto max-w-3xl">
          <div className="text-center">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
              <i className="ri-question-line" />
              常见问答 FAQ
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              关于最近黑料，你可能想知道
            </h2>
            <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              我们如何收集、更新与核实信息，以及如何跟上某件事的最新走向。
            </p>
          </div>

          <div className="mt-8 space-y-3">
            {faqs.map((f, i) => (
              <div
                key={i}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                  aria-expanded={open === i}
                >
                  <span className="font-heading text-base font-bold text-foreground-950">
                    {f.q}
                  </span>
                  <span
                    className={
                      "flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all " +
                      (open === i
                        ? "bg-primary-500 text-background-50"
                        : "bg-secondary-100 text-secondary-700")
                    }
                  >
                    <i
                      className={
                        "ri-add-line transition-transform duration-300 " +
                        (open === i ? "rotate-45" : "")
                      }
                    />
                  </span>
                </button>
                {open === i && (
                  <div className="px-5 pb-5">
                    <p className="border-l-2 border-primary-300 pl-3 text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}